import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=559a23ac&scoped=true&"
import script from "./contact-us.js?vue&type=script&lang=js&"
export * from "./contact-us.js?vue&type=script&lang=js&"
import style0 from "./contact-us.scss?vue&type=style&index=0&id=559a23ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559a23ac",
  null
  
)

export default component.exports